import { addDays } from 'date-fns'

import { CasePriority } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { BadgeColors, formatDate, parseISODate } from '@avantstay/backoffice-core'

export const getStatusCaseColor = (status?: string) => {
  if (!status) return BadgeColors.primary
  switch (status.toUpperCase()) {
    case 'NEW':
    case 'IN PROGRESS':
    case 'READY FOR WORK':
    case 'LIFE AND SAFETY AUDIT':
      return BadgeColors.accent
    case 'CX ESCALATION':
    case 'CASE REQUIRES UPDATE':
      return BadgeColors.riskVeryHigh
    case 'OBTAINING QUOTE':
    case 'MAINTENANCE SCHEDULED':
    case 'VENDOR SCHEDULED':
    case 'PENDING OWNER APPROVAL':
      return BadgeColors.channelAcquisitionWebsites
    case 'ON HOLD':
    case 'WAITING ON INVOICE':
    case 'WAITING ON PARTS':
    case 'WAITING ON OWNER RESPONSE':
    case 'WAITING FOR AVANTSTAY PAYMENT':
    case 'WAITING FOR OWNER PAYMENT':
      return BadgeColors.warning
    case 'COMPLETED - REVIEW':
    case 'COMPLETEDBILLINGREVIEW':
    case 'COMPLETED CX ESCALATION':
    case 'CLOSED':
    case 'CLEAN COMPLETE - REVIEW':
    case 'CLEAN COMPLETE - SEND HK BACK':
      return BadgeColors.success
    case 'CANCELLED':
    case 'SKIPPED':
    case 'CLOSED - MISSED':
    case 'CLOSED/LOST':
    case 'CLOSED/SAVED':
    case 'NEGOTIATION':
      return BadgeColors.neutral
    default:
      return BadgeColors.primary
  }
}

export const prioritySchemaBadgeColors = {
  [CasePriority.urgent]: BadgeColors.riskVeryHigh,
  [CasePriority.high]: BadgeColors.failure,
  [CasePriority.medium]: BadgeColors.warning,
  [CasePriority.low]: BadgeColors.success,
}

export const formatPeriodDates = (period?: string) => {
  if (!period) return undefined

  const dates = period.split('_')
  const [start, end] = dates

  if (!dates || dates?.every(date => date === '')) return undefined

  return { start, end: formatDate(addDays(parseISODate(end), 1)) }
}

export const getDatePeriodUrlParm = (sumStartDay: number, sumEndDay: number) => {
  return `${formatDate(addDays(new Date(), sumStartDay))}_${formatDate(addDays(new Date(), sumEndDay))}`
}

export const classNames = {
  dateFilter: 'date-filter',
  removePaddingFilter: 'remove-padding-filter',
  defaultFilter: 'default-filter',
}

export const EMPTY_FILTER_ID = '00000000-0000-0000-0000-000000000000'
